export default __webpack_public_path__ + "static/media/stu.ad0c1a59.png";